import React, { useEffect, useMemo, useState } from 'react';
import { Alert, Button, Spin } from 'antd';
import { ArrowLeftOutlined, LoadingOutlined } from '@ant-design/icons'; 
import loadTranslations from '../../services/cmxService';
import { fetchCourse } from '../../services/CourseService/CourseService';
import './styles.less';

const CourseLoader = ( { courseOptions, children } ) => {        
    const [ course, setCourse ] = useState();
    const [ loadedCMX, setLoadedCMX ] = useState( false );
    const [ hasCMXError, setCMXHasError ] = useState( false );
    const [ loadedCourse, setLoadedCourse ] = useState( false );
    const [ hasCourseError, setCourseHasError ] = useState( false );

    useEffect( () => { 
        const fetchCMXTranslations = async () => {
            const result = await loadTranslations( courseOptions.token, courseOptions.locale );       
            
            if ( result ) {
                setCMXHasError( false );
                setLoadedCMX( true );
            } else {
                setCMXHasError( true );
                setLoadedCMX( true );
            }
        };

        fetchCMXTranslations();  
    }, [] );
    
    useEffect( () => { 
        const loadCourse = async () => {
            const result = await fetchCourse( 
                courseOptions.token, 
                courseOptions.courseId,
                courseOptions.locale );       
            
            if ( result.success ) { 
                console.log( 'Course: ', result.course );
                setCourse( result.course );
                setCourseHasError( false );
                setLoadedCourse( true ); 
            } else {
                setCourseHasError( true );
                setLoadedCourse( true );
            }
        };

        loadCourse();  
    }, [] );

    useEffect( () => {
        console.log( 'Course Options: ', courseOptions );
    }, [ courseOptions ] );

    const isLoading = useMemo( () => {
        return !loadedCMX || !loadedCourse;
    }, [ loadedCMX, loadedCourse ] );

    const hasError = useMemo( () => {
        return hasCMXError || hasCourseError;
    }, [ loadedCMX, hasCourseError ] );

    const handleBackClick = () => {
        if ( courseOptions.referrer ) {
            location.href = courseOptions.referrer;
        } else {
            if ( window.history.length >= 0 ) {
                window.history.back();
            }
        }
    };

    return (       
        <div className="course-loader">
            { /* Loading state */ } 
            { isLoading &&
                <div className="spin-page-center-container">
                    <Spin indicator={ <LoadingOutlined style={ { fontSize: 32 } } spin /> } />
                </div>
            }

            { /* Error state */ } 
            { hasError &&
                <div className="error">

                    { /* Back button */ }
                    <Button 
                        className="back-button"
                        type="link"
                        icon={ <ArrowLeftOutlined /> } 
                        onClick={ handleBackClick }
                    >
                        Back
                    </Button>

                    <Alert
                        message={ 'Session Expired' }
                        description={ 'Your session has expired. Please click back button of your browser and login again to refresh your session.' }
                        type="warning"
                    /> 
                </div>
            }

            { /* Success state, render children */ } 
            { !isLoading && !hasError && course && 
                React.cloneElement( children, { courseOptions, course: course } )
            }
        </div>
    );
};

export default CourseLoader;
